<template>
  <!-- b-form-radio API'si (Aşama 2.3), Bootstrap 5 form-check işaretlemesi (Aşama 5). Tek başına v-model:
       modelValue/update:modelValue (açık `:checked` + `input` de sürer); FormRadioGroup içinde grubun değerini
       kullanır. change kullanıcı seçince seçilen değerle yayılır. -->
  <div class="form-check" :class="wrapperClasses">
    <input :id="safeId" type="radio" class="form-check-input" :name="computedName" :disabled="isDisabled"
           :required="isRequired" :aria-required="isRequired || null" :value="value" :checked="isChecked" @change="handleChange">
    <label class="form-check-label" :for="safeId"><slot /></label>
  </div>
</template>

<script>
  import { looseEqual, nextFormCheckId } from './formCheck';

  export default {
    name: 'FormRadio',
    emits: ['update:modelValue', 'input', 'change'],
    inject: { formRadioGroup: { default: null } },
    props: {
      modelValue: { default: undefined },
      checked: { default: null },
      value: { default: undefined },
      id: { type: String, default: undefined },
      name: { type: String, default: undefined },
      disabled: { type: Boolean, default: false },
      required: { type: Boolean, default: false },
      inline: { type: Boolean, default: false },
      size: { type: String, default: undefined }
    },
    data() {
      return {
        localId: nextFormCheckId('form-radio'),
        localChecked: this.formRadioGroup ? null : (this.modelValue === undefined ? this.checked : this.modelValue)
      };
    },
    computed: {
      safeId() {
        return this.id || this.localId;
      },
      boundChecked() {
        return this.modelValue === undefined ? this.checked : this.modelValue;
      },
      computedLocalChecked: {
        get() {
          return this.formRadioGroup ? this.formRadioGroup.localChecked : this.localChecked;
        },
        set(value) {
          if (this.formRadioGroup) this.formRadioGroup.localChecked = value;
          else this.localChecked = value;
        }
      },
      isChecked() {
        return looseEqual(this.computedLocalChecked, this.value);
      },
      computedName() {
        return (this.formRadioGroup ? this.formRadioGroup.groupName : this.name) || null;
      },
      isDisabled() {
        return this.formRadioGroup ? this.formRadioGroup.disabled || this.disabled : this.disabled;
      },
      isRequired() {
        return !!(this.computedName && (this.formRadioGroup ? this.formRadioGroup.required : this.required));
      },
      wrapperClasses() {
        const size = this.formRadioGroup ? this.formRadioGroup.size : this.size;
        return {
          'form-check-inline': this.formRadioGroup ? this.formRadioGroup.inline : this.inline,
          [`form-check-${size}`]: !!size
        };
      }
    },
    watch: {
      boundChecked(newValue, oldValue) {
        if (!this.formRadioGroup && !looseEqual(newValue, oldValue)) this.localChecked = newValue;
      },
      localChecked(newValue, oldValue) {
        if (!this.formRadioGroup && !looseEqual(newValue, oldValue)) {
          this.$emit('update:modelValue', newValue);
          this.$emit('input', newValue);
        }
      }
    },
    methods: {
      handleChange(event) {
        if (!event.target.checked) return;
        const value = this.value;
        this.computedLocalChecked = value;
        this.$nextTick(() => {
          this.$emit('change', value);
          if (this.formRadioGroup) this.formRadioGroup.$emit('change', value);
        });
      }
    }
  };
</script>
